// extracted by mini-css-extract-plugin
module.exports = {"title":"Burn_title__CYqr1","text":"Burn_text__2DmK-","info":"Burn_info__LXbUG","input":"Burn_input__2hPNp","btns":"Burn_btns__5f_7U","button":"Burn_button__5LXlN"};